export default __webpack_public_path__ + "static/media/fixed_point.666be5fa.png";